// extracted by mini-css-extract-plugin
export default {"Splash":"Splash_Splash__tVDlD","fade":"Splash_fade__E3XCn"};